import { Directive, Input } from '@angular/core';
import { ComplianceResultStatuses } from 'src/app/interfaces/compliance/compliance-result-statuses';

@Directive()
export abstract class ComplianceDisplayCardBase {
  @Input() VendorId?: number;
  @Input() CompanyId?: number;

  // Set this flag to determine if data should be loaded remotely.
  @Input() loadDataRemotely: boolean = false;

  getComplianceResultClass(
    result: ComplianceResultStatuses | 'NO EXACT MATCH' | 'REVIEW NEEDED'
  ) {
    const ResultToClassMap: {
      'NOT REQUIRED': 'compliance-not-required';
      MISSING: 'compliance-missing';
      PASSED: 'compliance-passed';
      FAILED: 'compliance-failed';
      EXEMPT: 'compliance-exempt';
      'NO EXACT MATCH': 'compliance-no-exact-match';
      'REVIEW NEEDED': 'compliance-review-needed';
    } = {
      'NOT REQUIRED': 'compliance-not-required',
      MISSING: 'compliance-missing',
      PASSED: 'compliance-passed',
      FAILED: 'compliance-failed',
      EXEMPT: 'compliance-exempt',
      'NO EXACT MATCH': 'compliance-no-exact-match',
      'REVIEW NEEDED': 'compliance-review-needed'
    };

    return ResultToClassMap[result];
  }
}
